import { Star } from "lucide-react";

const reviews = [
  { quote: "Rob and Brandon did a great job on our tile backsplash in our kitchen. They laid the new tile over the old tile and it looks great. No dust, little mess. One day to install the tile and one half day to grout. Good job on clean up too.", name: "Mark Rotacher", detail: "Google Review" },
  { quote: "I had an idea for an outside patio. A checkerboard pattern in black and gray. The problem was the cement flat work was uneven, didn't slope correctly and kind of a mess. RKD corrected the problems and left me with the tile floor that could compete with any of the floors in Versailles. Thanks Rob and RKD. I'd highly recommend them to anyone looking for quality tile work.", name: "Brett Ross", detail: "Google Review" },
  { quote: "The tile work Rob and his team did for me was on a new construction home. There was extensive tile work done on floors and walls in bathrooms and entries and decorative mosaic tiles around bathroom mirrors and tile use used for the kitchen backsplash. It took several months to complete the tile work. After living in the home for a year and a half we appreciate his attention to detail and his professional quality of work. Rob and his team, especially Brad, are awesome and I highly recommend them.", name: "Julie Bryner", detail: "Google Review" },
  { quote: "Rob and his crew did an awesome job on updating my bathroom shower. The tile looks great and they were really easy to work with. I'll definitely use them for future projects.", name: "Elizabeth Cornwall", detail: "Google Review" },
  { quote: "I reached out to Rob for some quick help. I needed one tile cut for a shower door installation. Prior to reaching out to RKD several companies turned me away. Rob was kind enough to take care of us and help move our shower glass installation forward. Rob earned a return customer for all of our future tile needs.", name: "Moore Machine", detail: "Google Review" },
  { quote: "RKD Tile did an excellent job laying tile in our bathroom, laundry room and garage entrance. The work was exceptional! Rob Dean, the owner, was very personable and patient while I explored different options. The workers were prompt, hard working, knowledgeable and very polite. It was apparent to me that Rob and his crew take great pride in doing a job well! I wholeheartedly recommend this company for anyone who is planning a remodel.", name: "Melinda Johnson", detail: "Google Review" },
  { quote: "Rob is the best in the industry. Strong honest work and won't steer ya wrong. I highly recommend RKD tile!", name: "Aztec Highway", detail: "Google Review" },
  { quote: "Wonderful experience. Prompt, professional, and helpful. They accepted a very difficult challenge (a mislaid tile shower floor) and fixed it perfectly. Highly recommend.", name: "Renee Lowry", detail: "Google Review" },
];

function ReviewCard({ review }: { review: typeof reviews[0] }) {
  return (
    <figure className="bg-card border border-border p-8 flex flex-col">
      <div className="flex gap-0.5 mb-5">
        {[...Array(5)].map((_, i) => (<Star key={i} className="h-4 w-4 fill-accent text-accent" />))}
      </div>
      <blockquote className="text-foreground/90 leading-relaxed flex-1">"{review.quote}"</blockquote>
      <figcaption className="mt-6 pt-5 border-t border-border">
        <div className="font-semibold text-foreground">{review.name}</div>
        <div className="text-sm text-muted-foreground">{review.detail}</div>
      </figcaption>
    </figure>
  );
}

export function Reviews() {
  const leftColumn = [...reviews, ...reviews, ...reviews];
  const rightColumn = [...reviews.slice().reverse(), ...reviews.slice().reverse(), ...reviews.slice().reverse()];

  return (
    <section id="reviews" className="py-20 md:py-28 bg-background overflow-hidden">
      <div className="container-prose">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="eyebrow">Reviews & trust</span>
          <h2 className="mt-3 font-display text-3xl md:text-5xl text-foreground leading-tight">Long-term relationships, delivered one project at a time.</h2>
          <div className="mt-6 flex items-center justify-center gap-1">
            {[...Array(5)].map((_, i) => (<Star key={i} className="h-5 w-5 fill-accent text-accent" />))}
            <span className="ml-3 text-sm text-muted-foreground">5.0 across Google Reviews</span>
          </div>
        </div>

        <div className="relative grid md:grid-cols-2 gap-6 max-h-[720px] overflow-hidden">
          {/* Fade masks */}
          <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-background to-transparent z-10 pointer-events-none" />
          <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background to-transparent z-10 pointer-events-none" />

          {/* Left column: top to bottom */}
          <div className="relative overflow-hidden">
            <div className="flex flex-col gap-6 animate-scroll-down hover:[animation-play-state:paused]">
              {leftColumn.map((r, i) => (
                <ReviewCard key={`left-${i}`} review={r} />
              ))}
            </div>
          </div>

          {/* Right column: bottom to top */}
          <div className="relative overflow-hidden hidden md:block">
            <div className="flex flex-col gap-6 animate-scroll-up hover:[animation-play-state:paused]">
              {rightColumn.map((r, i) => (
                <ReviewCard key={`right-${i}`} review={r} />
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-wrap justify-center items-center gap-8 text-xs tracking-[0.2em] uppercase text-muted-foreground">
          <span>· BBB A+ Rated ·</span><span>· Licensed & Insured ·</span><span>· 30 Years ·</span><span>· Builder's Choice 3× ·</span>
        </div>
      </div>
    </section>
  );
}
